import {B2C_URL_SIGNIN} from '../../env_settings';
export const ClearStorage = ()=>{
	sessionStorage.clear();
	window.location.href=B2C_URL_SIGNIN;
}